import React from 'react';

import PlusmembershipDisplay from '~/domains/plusMembership/components/PlusMembershipDisplay';
import InfiniteProductDisplay from '~/domains/products/InfiniteProductDisplay';
import ProductFilters from '~/domains/products/ProductFilters';
import { useInfiniteShowcaseQuery } from '~/domains/showcase/hooks';
import { useRouterQueryByKey } from '~/hooks/url';
import type { OAISchema } from '~/types/openapi';

export function ShowcaseContainer() {
  const code = useRouterQueryByKey('code', 'string');

  const { count, pages, fetchNextPage, hasNextPage } =
    useInfiniteShowcaseQuery();

  if (code === 'm_membership' || code === 'plusmembershipweek') {
    return <PlusmembershipDisplay code={code} viewCount />;
  }

  return (
    <>
      <ProductFilters />
      <InfiniteProductDisplay
        totalCount={count}
        data={(pages || []) as OAISchema['MarketSelectProductResponseV2'][]}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        sortType="DISPLAY_RANK"
      />
    </>
  );
}
